export default "__VITE_PUBLIC_ASSET__74b37866__"